import { render, staticRenderFns } from "./DetalheUploadWhatsapp.vue?vue&type=template&id=75540f99&scoped=true"
import script from "./DetalheUploadWhatsapp.vue?vue&type=script&lang=js"
export * from "./DetalheUploadWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./DetalheUploadWhatsapp.vue?vue&type=style&index=0&id=75540f99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75540f99",
  null
  
)

export default component.exports